import Card from "./common/Card";
import Day from "./common/day";
import React, { useState, useEffect } from 'react';
import Form from "./common/form";
import Loading from "../components/common/loading"
import axios from "axios";
import { success, error } from "../components/common/notification"


const Weather = () => {

    // display weather based on data pulled form an api
    // displays 8 days - Current and 7 days
    const [zipcode, setzipcode] = useState('10001');
    const [currentCity, setcurrentCity] = useState(null);
    const [weathers, setweathers] = useState(null);
    const [errors, seterrors] = useState(null);
    const { REACT_APP_API_URL } = process.env;


    useEffect(() => {

        (async () => {

            const config = {
                locationConfig: {
                    url: 'https://us-zip-code-information.p.rapidapi.com/',
                    params: { zipcode: zipcode },
                    headers: {
                        'x-rapidapi-host': 'us-zip-code-information.p.rapidapi.com',
                        'x-rapidapi-key': `${REACT_APP_API_URL}`
                    }
                },
                weatherConfig: {
                    url: `https://api.openweathermap.org/data/2.5/forecast?zip=${zipcode}&cnt=8&units=imperial&appid=89cd7e88418b17b16fd77971996a6071`
                }
            }
            const { locationConfig, weatherConfig } = config
            const locationAPI = await axios.get(locationConfig.url, locationConfig)
                .then(res => res.data[0])
                .catch(err => {
                    error(`Error ${err.response.status} - Weather API is down! please try again later`)
                    seterrors(err.response.status)
                })
            const weatherAPI = await axios.get(weatherConfig.url)
                .then(res => res.data.list)
                .catch(err => {
                    error(`Error ${err.response.status} - Weather API is down! please try again later`)
                    seterrors(err.response.status)
                })
            setcurrentCity(locationAPI)
            setweathers(weatherAPI)

        })()
    }, [zipcode]);

    const handleSearch = input => {
        success('Success! Zipcode Changed')
        setzipcode(input.search)
    }
    console.log(zipcode)
    return (
        <>
            {errors !== null ? <Card children={<h1>Weather app is down</h1>} /> :

                <Card children={
                    currentCity === null && weathers === null ?
                        <Loading />
                        :

                        <>
                            <div className="container md:flex flex-row-reverse justify-between items-center mx-3">
                                <Form handleSubmit={handleSearch}
                                    inputStyles={'rounded-lg w-full text-kombuGreen placeholder:text-kombuGreen border-solid border-2 border-light-blue-500 p-2'}
                                    inputData={{ text: "text", name: "search", id: "search", placeholder: "Search by zipcode", min: 5, max: 5 }}
                                    icon={{ iconName: "FaSearch", iconStyles: "cursor-pointer text-gray-300 text-2xl hover:text-gray-500" }}
                                />
                                <h1 className="text-kombuGreen text-xl text-center">{currentCity.City === undefined && currentCity.State === undefined ? "loading..." : `${currentCity.City}, ${currentCity.State}`}</h1>
                            </div>
                            {/* Current Weather */}
                            <div className="container lg:grid grid-cols-2">
                                {weathers === null ? "loading" :
                                    <>
                                        {console.log(weathers[0])}
                                        <div className="container">
                                            <div className="container m-5">
                                                {/* Date */}
                                                <h2 className="font-bold p-1 text-center">{<Day date={weathers[0].dt_txt} />}</h2>
                                                <p className="text-l text-center text-xanadu">{`${weathers[0].weather[0].main} - ${weathers[0].weather[0].description}`}</p>
                                                <div className="container flex justify-center items-center">
                                                    {/* Tempurature */}

                                                    <img src={` http://openweathermap.org/img/wn/${weathers[0].weather[0].icon}@2x.png`} alt="logo"></img><h3 className="text-magicMint text-4xl text-center font-bold mr-4">{`${Math.floor(weathers[0].main.temp)}°F`}</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="container p-2 lg:flex flex-col">
                                            <div className="container mb-3">
                                                <p className="text-center text-gray-500"> Next Couple of Hours</p>
                                            </div>
                                            <div className="container lg:flex overflow-auto scroll-smooth ">
                                                {weathers.map(({ main, weather, dt_txt }, idx) =>

                                                    <div key={idx + 1} className="container mb-3 p-2 flex flex-col">
                                                        <h2 className="font-bold p-1 text-center">{<Day date={dt_txt} />}</h2>
                                                        <p className="text-l text-center text-xanadu">{`${weather[0].main} - ${weather[0].description}`}</p>
                                                        <div className="container flex justify-center items-center">
                                                            <div className="container p-2 rounded">
                                                                <h3 className=" text-magicMint text-lg text-center font-bold ">{`${Math.floor(main.temp)}°F`}</h3>
                                                            </div>
                                                            <div className="container w-24 h-24">
                                                                <img className="rounded-md" src={`http://openweathermap.org/img/wn/${weather[0].icon}@2x.png`} alt="logo"></img>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </>}
                            </div>
                        </>
                }>
                </Card>




            }
        </>);
}

export default Weather;